"use client";
import dynamic from "next/dynamic";
import { Section } from "@/app/lib/features/home/home.types";
import { useTrackView } from "@/app/hooks/useTrackView";

const DiscoverTabs = dynamic(
  () => import("../../elements/tabs/DiscoverTabs"),
);

interface DiscoverProductsSectionProps {
  section: Section;
  isFirst?: boolean;
}

const DiscoverProductsSection = ({ section, isFirst }: DiscoverProductsSectionProps) => {
  const trackRef = useTrackView("section", section.id);

  return (
    <section ref={trackRef} className="bg-linear-to-b from-muted border border-muted to-white p-2 sm:p-4 rounded-md">
      <div className="flex items-center justify-between mb-2 sm:mb-3">
        <h2 className="text-base sm:text-xl font-medium flex items-center gap-2">
          {section.style?.icon && (
            <span className="text-xl">{section.style.icon}</span>
          )}
          {section.title}
        </h2>
      </div>
      <DiscoverTabs section={section} isFirst={isFirst} />
    </section>
  );
};

export default DiscoverProductsSection;
